import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=261a9b4e&scoped=true"
import script from "./CompanyDetails.vue?vue&type=script&lang=ts"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&id=261a9b4e&lang=scss"
import style1 from "./CompanyDetails.vue?vue&type=style&index=1&id=261a9b4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261a9b4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('261a9b4e')) {
      api.createRecord('261a9b4e', component.options)
    } else {
      api.reload('261a9b4e', component.options)
    }
    module.hot.accept("./CompanyDetails.vue?vue&type=template&id=261a9b4e&scoped=true", function () {
      api.rerender('261a9b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/company/components/CompanyDetails.vue"
export default component.exports